import JublyLogo from './JublyLogo';
import { useBranding } from '../hooks/useBranding.jsx';

/**
 * The brand mark for the current host. On an app (custom-domain) host this is the app's
 * own logo, or a neutral monogram — never the Jubly hummingbird. Jubly hosts get JublyLogo.
 */
export default function BrandMark({ size = 28, className = '', rounded = 'rounded' }) {
  const branding = useBranding();
  if (!branding.isApp) return <JublyLogo size={size} className={className} />;
  const box = { width: size, height: size };
  if (branding.logoUrl && branding.logoKind === 'image') {
    return <img src={branding.logoUrl} alt={`${branding.name} logo`} style={box} className={`${rounded} object-contain ${className}`} />;
  }
  return (
    <span
      aria-label={branding.name ? `${branding.name} logo` : undefined}
      style={{ ...box, fontSize: Math.round(size * 0.5) }}
      className={`${rounded} inline-flex items-center justify-center bg-slate-700 text-white font-bold select-none ${className}`}
    >
      {branding.pending ? '' : branding.monogram}
    </span>
  );
}
